export default "__VITE_ASSET__5wjN9DDl__"